<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>Login - Legacy HIPAAMATE</h1>
                <p class="text-muted">Sign In to your account</p>
                <hm-alert />
                <b-form @submit.prevent="onSubmit">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      name="email"
                      type="text"
                      class="form-control"
                      placeholder="Email"
                      autocomplete="email"
                      v-model="email"
                      v-validate="'required|email'"
                      :disabled="!ready"
                      :class="{
                        'is-invalid': errors.has('email') && submitted
                      }"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      name="password"
                      :type="passwordInputType"
                      class="form-control"
                      placeholder="Password"
                      autocomplete="current-password"
                      v-model="password"
                      v-validate="'required'"
                      :disabled="!ready"
                      :class="{
                        'is-invalid': errors.has('password') && submitted
                      }"
                    />
                    <b-input-group-append>
                      <b-input-group-text @click="onTogglePassword">
                        <i v-show="!showPassword" class="fa fa-eye"></i>
                        <i v-show="showPassword" class="fa fa-eye-slash"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button
                        variant="link"
                        class="px-0"
                        :disabled="!ready"
                        to="/forgot"
                        >Forgot password?</b-button
                      >
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button
                        type="submit"
                        variant="primary"
                        class="px-4"
                        :disabled="!ready"
                      >
                        <i class="fa fa-refresh fa-spin" v-if="!ready"></i>
                        Login
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { authService } from "@/services";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      ready: true,
      submitted: false
    };
  },
  computed: {
    passwordInputType() {
      return this.showPassword ? "text" : "password";
    }
  },
  methods: {
    ...mapActions({
      alertClear: "alert/clear",
      alertSuccess: "alert/success",
      alertError: "alert/error",
      alertException: "alert/exception",
      fetchProgress: "progress/fetch",
      updateToken: "user/update"
    }),
    onSubmit() {
      this.ready = false;
      this.submitted = true;
      this.alertClear();

      this.$validator
        .validate()
        .then(valid => {
          if (valid) {
            return authService
              .login(this.email, this.password)
              .then(resp => {
                this.$gtag.event("login", { method: "app" });
                return this.onSetToken(resp);
              })
              .catch(err => {
                if (err && err.status === 462) {
                  // user is not confirmed yet!
                  this.$router.push({
                    name: "Confirm",
                    params: { email: this.email }
                  });
                } else {
                  this.$gtag.event("login_error", {
                    event_category: "engagement"
                  });
                  this.alertException({
                    err,
                    message: "Invalid email or password."
                  });
                }
              });
          } else {
            this.alertError("Please enter a valid email address and password.");
          }
        })
        .finally(() => {
          this.ready = true;
        });
    },
    onTogglePassword() {
      this.showPassword = !this.showPassword;
    },
    onSetToken(token) {
      this.ready = false;
      this.updateToken(token);

      // check for a license
      console.log("Checking license...");
      return this.$store
        .dispatch("user/fetchLicense")
        .then(license => {
          if (!license.hasLicense) {
            // no license, send to setup
            this.$router.push("/setup/location");
          } else if (!license.isActive) {
            // license is expired, send to renewal
            this.$router.push("/renew");
          } else {
            // license is good, download progress info and send to dashboard
            return this.fetchProgress().then(() => {
              this.$router.push(this.$route.query.redirect || "/");
            });
          }
        })
        .catch(err => {
          this.alertException({
            err,
            message: "Error checking license status."
          });
        })
        .finally(() => {
          this.ready = true;
        });
    }
  },
  created() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }

    if (this.$route.params.email) {
      this.email = this.$route.params.email;
    }

    if (this.$route.params.msg) {
      this.alertSuccess(this.$route.params.msg);
    }

    if (this.$route.query.token) {
      this.onSetToken(this.$route.query.token);
    }
  },
  watch: {
    // you have to use function syntax here, as warned in the docs
    "$route.query.email": function(newVal, oldVal) {
      this.email = newVal;
    },
    "$route.query.msg": function(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.alertSuccess(newVal);
      }
    },
    "$route.query.token": function(newVal, oldVal) {
      this.onSetToken(newVal);
    }
  }
};
</script>
